import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { roles } from 'src/app/Enums/roles';
import { CustomerOrderDetail } from 'src/app/models/customer/customer.model';
import { AdminOrderListService } from 'src/app/services/admin-order-list.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { CustomerService } from 'src/app/services/customer.service';
import { HomePageService } from 'src/app/services/home-page.service';

@Component({
  selector: 'app-customer-download-invoice',
  templateUrl: './customer-download-invoice.component.html',
  styleUrls: ['./customer-download-invoice.component.css']
})
export class CustomerDownloadInvoiceComponent implements OnInit {
  customerOrders: CustomerOrderDetail = new CustomerOrderDetail();
  id: number;
  productId : number;
  warrantyId: string;
  warrantyYearPrice1: string;
  warrantyYearPrice2: string;
  newWarrantyPlan: string;
  Loader: boolean = false;
  warrantyYearPrice3: string;
  localStorageService: LocalstorageService;
  userRole: string;
  printSaveButton: boolean = true;
  customerDeliveryPrice: string;

  constructor(private customerService: CustomerService, private _adminOrderListService: AdminOrderListService, private _localStorageService: LocalstorageService, private homePageService: HomePageService,  private _customerService: CustomerService, private alertify: AlertifyService, private route: ActivatedRoute, private router: Router,) { 
    this.localStorageService = _localStorageService;
    this.userRole = LocalstorageService.getUserRole();
  }

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.id = +param.id
    })
    if (localStorage.getItem('role') == roles.Customer.toString()) {
      if (this.localStorageService.getToken()) {
        this.getinvoiceDetail();
      } else {
        this.router.navigate(['/login'], { queryParams: { return: window.location.href } });
      }
    } else {
      if (this.localStorageService.getToken()) {
        this.getAdminInvoiceDetail();
      } else {
        this.router.navigate(['/login'], { queryParams: { return: window.location.href } });
      }
    }  
  }

   getinvoiceDetail() {
    this.customerOrders.id = this.id;
    this.Loader= true;
    this.customerService.GetCustomerOrderDetail(this.customerOrders.id).subscribe((response) => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.customerOrders = responseBody.responseData;
        this.customerDeliveryPrice = this.customerOrders.deliveryPrice;
        }
        this.warrantyId = this.customerOrders.warrantyId;
        if(this.warrantyId) {
          var durationWithPrizeList = JSON.parse(this.customerOrders.warrantyPrice);
          for (var i = 0; i < durationWithPrizeList.length; i++) {
            if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            }
            else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } 
            if (this.customerOrders.applicationInstallationPrice == '1') {
              this.warrantyYearPrice2 = durationWithPrizeList[i].Price;
            }
          }
          this.warrantyYearPrice3 = this.customerOrders.warrantyYear;
          if(this.warrantyYearPrice3 >= "1"){
            this.newWarrantyPlan = this.warrantyYearPrice3;
           }
        }
    })
   }

   getAdminInvoiceDetail() {
    this.customerOrders.id = this.id;
    this.Loader= true;
    this._adminOrderListService.getAdminInvoiceOrderDetail(this.customerOrders.id).subscribe((response) => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.customerOrders = responseBody.responseData;
        this.customerDeliveryPrice = this.customerOrders.deliveryPrice;
        }
        this.warrantyId = this.customerOrders.warrantyId;
        if(this.warrantyId) {
          var durationWithPrizeList = JSON.parse(this.customerOrders.warrantyPrice);
          for (var i = 0; i < durationWithPrizeList.length; i++) {
            if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            }
            else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } 
            if (this.customerOrders.applicationInstallationPrice == '1') {
              this.warrantyYearPrice2 = durationWithPrizeList[i].Price;
            }
          }
          this.warrantyYearPrice3 = this.customerOrders.warrantyYear;
          if(this.warrantyYearPrice3 >= "1"){
            this.newWarrantyPlan = this.warrantyYearPrice3;
           }
        }
    })
   }

   print() {
    setTimeout(() => {
      let a = document.querySelectorAll("[id='pageNo']");
      window.print();
    }, 1000);
    setTimeout(() => {
    this.printSaveButton = false;
    }, 300);
    setTimeout(() => {
      this.printSaveButton = true;
      }, 2000);
  }
  
}
